module.exports = __webpack_public_path__ + "static/img/correct.70f52662.svg";